/**
 * SmallTabsHider
 * This plugin is used for smalltabs to show tab content in a box below tab-bar
 * calculates on load and resize
 */


export default class SmallTabsHider {

    // constructor
    constructor(selector) {

        this.$plugin = $(selector);

        // cancel if non existing element
        if (this.$plugin.length === 0) {
            return false;
        }

        // class variables
        this.$elements = this.$plugin.find('[data-tncp-smalltabshider="el"]');
        this.$container = this.$plugin.find('[data-tncp-smalltabshider="container"]');
        this.$more = this.$plugin.find('[data-tncp-smalltabshider="more"]');
        this.activeClass = 'active';

        // at first get the element width of each tab item of the current instance and save it as array
        this.elementWidths = this.getElementWidths();

        // init method
        this.init();
    }

    /**
     * init method
     * loads the basic stuff
     */
    init() {
        let vm = this;

        // resize event with debounce - event is submitted if resize event is finished and time is depleted - more performant as throttle
        $(window).on('resize', _.debounce(function () {
            vm.moveElements();
        }, 400));

        // if eventlisteners and document are loaded
        if (window.addEventListener) {
            window.addEventListener('load', function() {
                vm.moveElements();
            });
        }

        // opens container (small devices) on hover/click
        vm.$more.hover(
            function(e) {
                vm.$container.addClass(vm.activeClass);
                e.stopPropagation();
            }, function(e) {
                vm.$container.removeClass(vm.activeClass);
                e.stopPropagation();
            }
        );
    }


    /**
     * moves elements to tab or container
     * depends on current width of screen width (calculated by this.visibilityStack)
     */
    moveElements() {
        let vm = this;

        // get the current visibilityStack
        let visibilityStack = vm.visibilityStack();

        // iterate through elements and decide to move them into tab bar or to container
        _.forEach(this.$elements, (el, index) => {
            let $movableElement = vm.$elements.eq(index);
            if (visibilityStack[index]) {
                $movableElement.detach().appendTo(vm.$plugin);
            } else {
                $movableElement.detach().appendTo(vm.$container);
            }
        });

        // if more-container does contain elements => show it
        // else hide it
        if (vm.$container.find('*').length) {
            vm.$more.addClass(this.activeClass);
        } else {
            vm.$more.removeClass(this.activeClass);
        }
    }


    /**
     * get elements widths in an array on pageload
     * this method is only called once to get the index and width of a tab instance
     *
     * @returns {Array}
     */
    getElementWidths() {

        // clone $plugin and set it to visibility hidden
        let $clone = this.$plugin.clone()
            .css("visibility","hidden")
            .appendTo($('body'));
        $clone.find('[data-tncp-smalltabshider="container"]').show();
        $clone.find('[data-tncp-smalltabshider="more"]').show();

        // create new result array
        let elArr = [];

        // set temporaryWidth to calculate it in iteration
        let temporaryWidth = 0;

        // iterate through clone abd data-tncp-smalltabshider="el" items and sum the widths for each index
        _.forEach($clone.find('[data-tncp-smalltabshider="el"]'), (el) => {
            temporaryWidth += $(el).innerWidth();
            elArr.push(temporaryWidth)
        });

        // remove clone
        $clone.remove();

        // return result array
        return elArr;
    }


    /**
     * plugin width calculation
     * creates an array which contains a boolean if the tab-element fits into the container on current screen width
     * uses a hidden clone of this.$plugin to calculate the width due to the fact that display none items doesn't have a width
     *
     *
     * @returns {Array}
     */
    visibilityStack() {

        let vm = this;

        // clone $plugin and set it to visibility hidden
        let $clone = this.$plugin.clone()
            .css("visibility","hidden")
            .appendTo($('body'));

        // calculate the plugin width minus a small offset value
        let pluginWidth = $clone.innerWidth() - 30;

        // create new result array
        let elArr = [];

        // iterate through clone abd data-tncp-smalltabshider="el" items and check if which elements fit into view and which not
        // true = fit into plugin-container, false = does not fit into plugin-container
        _.forEach(vm.elementWidths, (widthValue) => {
            if (widthValue >= pluginWidth) {
                elArr.push(false)
            } else {
                elArr.push(true)
            }
        });

        // remove clone
        $clone.remove();

        // return result array
        return elArr;
    }
}



